module.exports = __webpack_public_path__ + "img/paper-9.f75f66e5.png";